/**
 * Project client
 *
 * Created by stefensuhat on 10/31/18 10:10 AM
 */


const snackbar = {
    name: 'snackbar',
    state: { content: null },
    reducers: {
        create: (state, payload) => ({ ...state, content: payload }),
        remove: state => ({ ...state, content: null }),
    },
};

export default snackbar;
